import { createSlice } from '@reduxjs/toolkit';
const getTjenesteTeksterKey = (tjenesteNavn, language) => `${tjenesteNavn}.${language}`;
const initialState = {};
const customHjelpeteksterSlice = createSlice({
    name: 'customHjelpetekster',
    initialState,
    reducers: {
        // Setter default hjelpetekst for en tjeneste
        setDefaultHjelpetekst(state, action) {
            const key = getTjenesteTeksterKey(action.payload.tjenesteNavn, action.payload.language);
            state[key] = {
                ...state[key],
                hjelpeskuffTittel: action.payload.hjelpeskuffTittel,
                hjelpeskuffTekst: action.payload.hjelpeskuffTekst,
            };
        },
        // Legger til hjelpetekster for en tjeneste
        addHjelpetekster(state, action) {
            const key = getTjenesteTeksterKey(action.payload.tjenesteNavn, action.payload.language);
            state[key] = {
                ...state[key],
                hjelpetekster: [...(state[key]?.hjelpetekster ?? []), ...action.payload.hjelpetekster],
            };
        },
    },
});
export const { setDefaultHjelpetekst, addHjelpetekster } = customHjelpeteksterSlice.actions;
export default customHjelpeteksterSlice.reducer;
